import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=21025bd4"
import script from "./TableAction.vue?vue&type=script&lang=js"
export * from "./TableAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports